import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteTopicStart,
  deleteTopicSuccess,
  deleteTopicFailure,
} from "../reducer";
import { Notify } from "@flexisaf/flexibull2";
import { httpDeleteTopic } from "../../../services/autoComplete";

export function* handleDeleteTopic({ payload }) {
  const { cb, data } = payload;

  const response = yield call(httpDeleteTopic, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(deleteTopicSuccess());
    Notify("Topic deleted successfully", { status: "success" });
    if (cb) {
      cb();
    }
  } else {
    yield put(deleteTopicFailure(message || raw.error));
    Notify(message || raw.error, { status: "error" });
  }
}

export default function* onTopicDelete() {
  yield takeLatest(deleteTopicStart.type, handleDeleteTopic);
}
